import * as apiActions from 'aster-foundation/core/astercore/auth/login/redux/actions';
import { familyMember } from 'aster-foundation/core/astercore/profile/profile/redux/actions';
import { getDataFromCookie } from 'aster-foundation/core/common/utils/cookieHelper';
import { SMART_LOOK_KEY } from 'aster-foundation/core/common/utils/ApiConst';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Smartlook from 'smartlook-client';
import { dataLayerAddFamilyMemberinitiation, dataLayerSendEvent } from '@common/Utility/analytics-utils';
import { errorHandling } from '@common/Utility/common-utils';
import { ASTER_PURCHASE_TYPES, ONE_ASTER_CATEGORY_HOME, SCREEN_NAME, SCREEN_TYPE } from '@common/Utility/constants';
import { EventEmitter } from '@common/Utility/eventEmitter';
import AllUpcomingOrders from '../AllUpcomingOrders/AllUpcomingOrders';
import DynamicDashboard from '../DynamicDashboard/DynamicDashboard';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import HeaderBelow from '../HeaderBelow/HeaderBelow';
import HereToHelp from '../HereToHelp/HereToHelp';
import Loader from '../Loader/Loader';
import TopBar from '../TopBar/TopBar';
import { CommonHomeStyled } from './CommonHomePageStyled';
import useIsNotSafari from '../../Utility/hooks';
import { useAuth } from '@common/AuthService';
import RxHome from 'TeleConsultation/RxPreorder/RxHomepage/RxHome';
import { ToastControl } from '../Forms';
import useScrollHandler from '@common/Context/useScrollHandler';
import { IC_TICK } from '../../Assets/images';
import LabTestReportHomepage from 'TeleConsultation/LabTestReportHomepage';
import { MY_ASTER_CATEGORY, PAGE_NAME, PAGE_TYPE } from '@common/Constants/analytics';

const CommonHomePage = (props) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const scrollY = useScrollHandler();
  const { authCtx } = useAuth();
  const { cmsAscoResult } = props;
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource);
  const guestLogin = useSelector((state) => state?.astercore?.guestAccessToken?.data);
  const familyMemberLoading = useSelector((state) => state?.astercore?.familyMember?.isFetching);
  const [isGuest, setIsGuest] = useState(true);
  const [fallbackLoader, setfallbackLoader] = useState(true);
  const [isReload, setIsReload] = useState(true);
  const orderReference = router?.query?.ref;
  const mobileWithCode = userLogin?.telecom?.find((item) => item.system === 'phone')?.value;
  const [isMemberAdded, setIsMemberAdded] = useState(false);

  const checkUserApiCall = () => {
    dispatch(
      apiActions.checkUserExist({
        params: {
          mobile: encodeURIComponent(authCtx?.idTokenParsed?.mobile_number),
          id: authCtx?.idTokenParsed?.sub,
        },
        onSuccess: () => {},
        onFailure: (err) => {
          errorHandling(err, true);
        },
      }),
    );
  };

  useEffect(() => {
    Smartlook.init(SMART_LOOK_KEY);
  }, []);

  const getUserLoginMemo = useMemo(() => userLogin?.id, [userLogin?.id]);

  const getGuestLoginMemo = useMemo(() => guestLogin?.accessToken, [guestLogin?.accessToken]);

  const getExistingFamilyMembers = () => {
    dispatch(
      familyMember({
        mobile: encodeURIComponent(mobileWithCode),
        onSuccess: (response) => {
          if (response?.body?.length > 0) {
            dataLayerAddFamilyMemberinitiation(
              'manage family members',
              PAGE_TYPE?.PROFILE,
              MY_ASTER_CATEGORY?.ASCO,
              'asco homepage',
            );
          }
        },
        onFailure: (err) => {
          errorHandling(err);
        },
      }),
    );
  };

  const callHisApi = () => {
    if (userLogin?.extension.find((item) => item.url === 'completeProfile')) {
      EventEmitter.dispatch('checkPatientInHis', userLogin);
      checkUserApiCall();
    }
  };

  useEffect(() => {
    if ((getDataFromCookie('Guest_Token') === localStorage.getItem('guestToken') && guestLogin) || userLogin) {
      if (userLogin) {
        callHisApi();
        setIsGuest(false);
        getExistingFamilyMembers();
      }
      setIsReload(!isReload);
    }
  }, [getUserLoginMemo, getGuestLoginMemo]);

  useEffect(() => {
    if (('CheckFamilyMemberinHis' in EventEmitter.events)) {
      EventEmitter.subscribe('CheckFamilyMemberinHis', () => getExistingFamilyMembers());
    }
    return () => {
      EventEmitter.unsubscribe('CheckFamilyMemberinHis', () => getExistingFamilyMembers());
    };
  }, []);

  useEffect(() => {
    localStorage.removeItem('confirmHeader');
    localStorage.removeItem('confirmText');
    localStorage.removeItem('appointmentSection');
    localStorage.removeItem('appointmentFilterName');
    localStorage.removeItem('clinicId');
    localStorage.removeItem('appointmentId');
    sessionStorage.removeItem('CurrentPage');
  }, []);

  useEffect(() => {
    if (orderReference) {
      dataLayerSendEvent('payment_cancelled_or_failed', {
        purchase_type: ASTER_PURCHASE_TYPES.DOCTOR,
        error: 'Payment could not be processed',
      });
    }
  }, [orderReference]);

  useEffect(() => {
    setfallbackLoader(sessionStorage.getItem('bookAppointmentLogin'));
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsMemberAdded(false);
    }, 3000);
  }, [isMemberAdded]);

  const analyticsProps = { 
    page_type: "homepage",
    myaster_category: "asco",
    screen_name: "asco homepage",
    referrer_page: props?.referrerPage
  };

  const isNotSafari = useIsNotSafari();

  return (
    <CommonHomeStyled isNotSafari={isNotSafari}>
      <Loader isLoading={fallbackLoader || familyMemberLoading} />
      {!fallbackLoader && <TopBar screenName={SCREEN_NAME?.ASCO} pageType={PAGE_NAME?.ASCO} />}
      <Header globalSearch screenName={SCREEN_NAME?.ASCO} pageType={PAGE_NAME?.ASCO} />
      {isMemberAdded ? (
        <ToastControl
          className={`${scrollY > 38 ? 'toast-fixed ' : ''}`}
          text="Family Member Added"
          variant="green-dark-box justify-content-center floating-wrapper toast-image"
          imgBox
          imgError={IC_TICK}
        />
      ) : null}
      {!fallbackLoader && (
        <div className="pageContent pb-0 bg-grey">
          <HeaderBelow screenName={SCREEN_NAME?.ASCO} pageType={PAGE_NAME?.ASCO} />
          <AllUpcomingOrders outerClass="mobile-book-appoint-spacing" screenName={SCREEN_NAME?.ASCO} />
          <RxHome screenName="asco homepage" pageReferrer="" />
          <LabTestReportHomepage />
          <DynamicDashboard
            dynamicValue={{
              cmsResult: cmsAscoResult,
              type: ONE_ASTER_CATEGORY_HOME.CORE,
              screenType: SCREEN_TYPE.CORE,
              category: ONE_ASTER_CATEGORY_HOME.CORE,
              referrerPage: props?.referrerPage,
              page_type: props?.page_type,
              screenName: props?.screenName,
              myaster_category: props?.myaster_category,
              analyticsProps: analyticsProps
            }}
            setIsMemberAdded={setIsMemberAdded}
          />
          <HereToHelp />
          <Footer guest={isGuest} screenName={SCREEN_NAME?.ASCO} pageType={PAGE_NAME?.ASCO} />
        </div>
      )}
    </CommonHomeStyled>
  );
};

CommonHomePage.propTypes = {
  cmsAscoResult: PropTypes.object,
};

CommonHomePage.defaultProps = {
  cmsAscoResult: {},
};

export default CommonHomePage;
